import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AusschreibungOverviewComponent } from "../features/ausschreibung/components/ausschreibung-overview/ausschreibung-overview.component";
import { FoerderprogrammResolver } from "../resolver/ausschreibung/foerderprogramm.resolver";
import { PortalkonfigurationResolver } from "../resolver/portalkonfiguration/portalkonfiguration.resolver";

export class AusschreibungRoutingFactory extends BaseRoutingFactory {

    private readonly coreAusschreibungRoute: Routes = [
        {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full'
        },
        {
            path: 'overview',
            component: AusschreibungOverviewComponent,
            resolve: {
                portalkonfiguration: PortalkonfigurationResolver,
                foerderprogramme: FoerderprogrammResolver
            },
        },
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreAusschreibungRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute!.push(route);
        }
    }

}